const english = {
    GENERAL: {
        LUF: "Download Lookup Files",
        CREATED: "Created",
        COMPANY_ADMIN: "Company admin",
        SHOW_TERMS: "Show terms",
        EXPEDIENTS_AGENCIES: "Expedients by agencies",
        EXPEDIENTS: "Expedients",
        AGENCIES: "Agencies",
        COMPANIES: "Companies",
        DATASETS: "datasets",
        TRAVELERS: "Travelers",
        COMPANY: "Company",
        UPDATE_DATA: "Update data",
        PER_PERSON_ABBREVATION: "p. p.",
        NEW: "new",
        OLD: "old",
        CALCULATION: "Calculation",
        ADD_TO: "Add to",
        TYPE: "type",
        AND: "and",
        OR: "or",
        FUEL_CONSUMPTION: "Fuel consumption",
        GUEST: "Guest",
        GUESTS: "Guests",
        ERROR: "Error",
        PERSON: "Person",
        LITER: "liter",
        KW_H: "kWh",
        DISTANCE: "Distance",
        NO_AGENCY: "No agency",
        NONE: 'None',
        CHECKOUT: "Checkout",
        ASTERIKS: "*",
        STAR: 'Star',
        STARS: 'Stars',
        CALENDAR: 'Calendar',
        NO_CUSTOMER: "No customer",
        CUSTOMER: 'Customer',
        CREATE: 'Create',
        POWERED_BY: "Powered by",
        DESCRIPTION: "Description",
        START_DATE: "Start date",
        ADD_TITLE: "Add title",
        ADD_DESCRIPTION: "Add description",
        TRAVEL_COMPONENT_NAME: "Travel Component name",
        JOURNEY_NAME: "Name of journey",
        END_DATE: "End date",
        CONTACT_PERSON: "Contact person",
        CUSTOMER_FIRST_NAME: "Customer first name",
        CUSTOMER_LAST_NAME: "Customer last name",
        CUSTOMER_EMAIL: "Customer email",
        CUSTOMER_PHONE: "Customer phone number",
        CUSTOMER_STREET: "Customer street",
        CUSTOMER_CITY: "Customer city",
        CUSTOMER_HOUSE_NUMBER: "Customer house number",
        CUSTOMER_ZIP_CODE: "Customer zip code",
        TOTAL_EMISSIONS: "Total emissions",
        BACK: "Back",
        YES: "Yes",
        UPDATE_TRAVEL_COMPONENT: "Update Travel Components",
        NO: "No",
        ADMIN: "Admin",
        EMAIL: "E-Mail",
        PHONE: 'Phone number',
        DAY: "Day",
        ABORT: "Return",
        SAVE: "Save",
        LOAD: "Load",
        TRANSPORT: "Transport",
        ACCOMMODATION: "Accommodation",
        UNDERTAKING: "Activity",
        ADD: "Add",
        TOTAL: "Total",
        JOURNEY: "Journey",
        DURATION: "Duration",
        PERSONS: "Persons",
        PROCEED: "Proceed",
        DAYS: "Days",
        FROM: "from",
        LAST_EDITED: "last edited",
        EDITED: "edited",
        DELETE: "Delete",
        SEARCH: "Search",
        SHARE: "Share",
        DATE_OF_ACTIVITY: "Date",
        TRANSFERS: "Transfers",
        EMISSIONS: "Emissions",
        SPINNER: "Spinner, shown as long as needed to load the data.",
        COPIED: "Copied",
        PASSENGER: 'Person',
        PASSENGERS: 'Persons',
        OPTION_OPTIONAL: 'Optional',
        FOR: "for",
        CALCULATE: "Calculate",
        CALCULATE_AGAIN: "Calculate again",
        UNDO: "Undo",
        DATE: "Date",
        FAILED: "Failed",
        TOTAL_CO2: "Total CO₂",
        RESET: "Reset",
        SELECT_ALL: "Select all",
        UNSELECT_ALL: "Unselect all",
        OK: "OK",
        EMISSIONS_CALCULATED: "Emissions calculated successfully!",
        GROUP_TRAVEL_COMPONENTS: "Group Travel Components",
        UNGROUP_TRAVEL_COMPONENTS: "Ungroup Travel Components",
        TRAVELERS_COUNT: "Persons",
        EMISSIONS_PER_PERSON: "Emissions per person",
        PER_PERSON: "per person",
        INVITE: "Invite",
        TRAVEL_COMPONENTS: "Travel Components",
        TRAVEL_COMPONENTS_DATIV: "Travel Components",
        CO2_E_EXPLANATION: 'All emissions are given in "kg CO₂ equivalent" (kg CO₂e); this corresponds to the amount of CO₂ that has the same climate-warming effect as the sum of all emissions produced, including other greenhouse gases (e.g. methane) and effects (contrails, ozone formation).',
        AGENCY: "Agency",
        AGENCY_NAME: "Agency name",
        USER: "User",
        USER_NAME: "User name",
        FIRST_CONTACT_PERSON: "1. Contact person",
        SECOND_CONTACT_PERSON: "2. Contact person",
        FIRST_CONTACT_PERSON_FIRST_NAME: "1. Contact person first name",
        FIRST_CONTACT_PERSON_LAST_NAME: "1. Contact person last name",
        SECOND_CONTACT_PERSON_FIRST_NAME: "2. Contact person first name",
        SECOND_CONTACT_PERSON_LAST_NAME: "2. Contact person last name",
        STREET: "Street",
        FIRST_NAME: "First name",
        LAST_NAME: "Last name",
        ADDITIONAL_ADDRESS_INFORMATION: "Additional information",
        ZIP_CODE: "Zip code",
        CITY: "City",
        COMPANY_NAME: "Company name",
        HOUSE_NUMBER: "House number",
        TELEPHONE_NUMBER_WITH_AREA_CODE_LABEL: "Telephone number with area code",
        COUNTRY_LABEL: "Country",
        COUNTRY_CODE_LABEL: "Country dialling code",
        HELP: "Help",
        TERMS: "Terms",
        AIRPORT: 'Airport',
        HOTEL: 'Hotel',
        FLIGHT: "Flight",
        EINEN: 'an',
        EIN: 'a',
        EINE: 'a',
        EDIT: 'Edit',
        AIRLINE: "Airline",
        COUNTRY: 'Country',
        COMPANY_EMAIL: 'Company email',
        AGENCY_EMAIL: 'Agency email',
        SKIP: "Skip",
        LOADING: "Loading...",
        CO2KGE: "CO₂KgE",
        TRAVEL_COMPONENT: "Travel Component",
        WEITEREN: 'another',
        WEITERES: 'another',
        ATTACH: "attach",
        REPLACE: "replace",
        CREATE_JOURNEY: "Create Journey",
        ADDRESS: "Address",
        START: "Start",
        DESTINATION: "Destination",
        STOPOVER: "Stopover",
        STOPOVERS: "Stopovers",
    },
    ARIA: {
        SORT: "Sortieren",
        CLOSE_OVERLAY: "Overlay schließen",
        CALENDAR: "Calendar",
        KLIMALINK_LOGO: "Logo of KlimaLink Association",
    },
    HINTS: {
        COMMON: {
            ROUNDED_VALUES: "Values per group are rounded and can differ from the original values",
        },
        EMISSION_CALCULATION: {
            COMMON: {
                TEXT: "Emissions were calculated at {{tier}}.",
                DIFFERENT_CALCULATED_CO_KG_E: "The recalculated emissions differ from the emissions calculated at the time of saving (new: {{currentEmissionsCo2KgE}}, old: {{previousEmissionsCo2KgE}}).",
            },
            HOTEL: {
                TEXT: "The emissions were calculated on {{tier}}.",
                PROPERTY: "hotel level",
                CITY: "city level",
                REGION: "region level",
                COUNTRY: "country level"
            },
            FLIGHT: {
                BETTER_CALCULATION_POSSIBILITY_SPECIFIC: "You can calculate the emissions of this section of the flight more precisely by adding further information such as airline or travel class.",
                BETTER_CALCULATION_POSSIBILITY_GENERAL: "You can calculate the emissions of at least one of the flight segments more precisely by adding further information such as airline, aircraft type or travel class.",
                PRECISE_CALCULATED: "The emissions were calculated using airline and/or aircraft type and/or service class. This results in a more accurate emissions calculation.",
                DIFFERENT_CALCULATED_CO_KG_E_SINGULAR: "The recalculated emissions for the flight segment {{leg}} differ from the emissions calculated at the time of saving (new: {{currentEmissionsCo2KgE}}, old: {{previousEmissionsCo2KgE}}).",
                DIFFERENT_CALCULATED_CO_KG_E_PLURAL: "For the following legs the recalculated emissions differ from the emissions calculated at the time of saving: {{legsWithValues}}."
            },
            CAR_BUS: {
                DEFAULT_DISTANCE_VALUE_USED: "A default distance value was used.",
                DERIVED_FUEL_CONSUMPTION_USED: "The fuel consumption was derived {{derivedFuelConsumption}}.",
                CAR_CATEGORY_DAYS_OF_USE_USED: "To calculate emissions, the car category {{carCategory}} and duration of {{days}} was used.",
                FUEL_CONSUMPTION: "The specified fuel consumption was used to calculate the emissions.",
                DISTANCE_USED: "To calculate the emissions, the specified distance was used, and the fuel consumption was derived {{derivedFuelConsumption}}.",
                DAYS_OF_USE: "The number of days driven is used to estimate the distance traveled per day. Fuel consumption is derived from a standard value for the specified vehicle type.",
                FROM_CAR_TYPE: "from car type",
                FROM_BUS_TYPE: "from bus type",
                FROM_ACRISS_CODE: "from Acriss code",
                FLAT_RATE_DISTANCE: "A flat-rate distance was set.",
                BETTER_CALCULATION_POSSIBILITIES: "You can calculate the emissions more precisely by adding further information such as {{values}}.",
            },
        },
        BUNDLE: {
            SAVED_DATA: "This is saved data.",
            HOTEL_NEW_NAME: "The hotel {{originalHotelName}} is named now {{newHotelName}}.",
            HOTEL_DISCONTINUED: "The hotel {{originalHotelName}} does not exist anymore.",
            HOTEL_CLASS_CHANGED: "The original hotel class was {{originalHotelClass}} and the new class is {{newHotelClass}}.",
            CALCULATED_WITH_NEW_DATA: "The emissions were calculated with the new data.",
            FLIGHT_NUMBER_AND_DATE_STRIPPED_OF_LEG: "The connection {{flightNumber}} ({{flightDate}}) no longer exists. Therefore, the flight number, date, airline, and aircraft type have been removed. The emissions calculation for these sections was carried out without considering the aircraft type and airline. This results in less accurate emissions calculations.",
            FLIGHT_NUMBER_AND_DATE_STRIPPED_OF_LEGS: "The connections {{legs}} no longer exists. Therefore, the flight number, date, airline, and aircraft type have been removed. The emissions calculation for these sections was carried out without considering the aircraft type and airline. This results in less accurate emissions calculations.",
            NEW_AIRPORT_UPON_LOADING: "The original airport ({{originalAirportName}}) has the same IATA code {{iata}}, but a different name ({{newAirportName}}) now. The emissions calculated were done with the new airport and its new location. Please double check and if necessary edit the airport and calculate the emissions anew.",
            NEW_AIRPORT_UPON_LOADING_SAME_COUNTRIES: "Hint: The original airport is located in {{originalAirportCountry}}, the new airport is located in {{newAirportCountry}}. Since they are located in the same country, it can be assumed that the location of the airport is the same and the calculated emissions are the same as the original ones.",
            NEW_AIRPORT_UPON_LOADING_DIFFERENT_COUNTRIES: "Hint: The original airport is located in {{originalAirportCountry}}, the new airport is located in {{newAirportCountry}}. Since they are located in different countries, it can be assumed that the location of the airport is different and the calculated emissions are different compared to the original ones.",
            NEW_AIRPORTS_UPON_LOADING: "The original airports ({{originalAirportNames}}}) have the same IATA codes ({{iatas}}), but different names ({{newAirportNames}}) now. The emissions calculated were done with the new airports and their new locations. Please double check and if necessary edit the airport and calculate the emissions anew.",
            NEW_AIRPORTS_UPON_LOADING_SAME_COUNTRIES: "Hint: All of the original airports are still located in the same countries (original countries: {{originalAirportCountries}}, new countries: {{newAirportCountries}}). Since they are located in the same countries, it can be assumed that the locations of the airports are the same and the calculated emissions are the same as the original ones.",
            NEW_AIRPORTS_UPON_LOADING_DIFFERENT_COUNTRIES: "Hint: At least one of the airports is located in a different country now (original countries: {{originalAirportCountries}}, new countries: {{newAirportCountries}}). Since at least one of the airports is located in different countries, it can be assumed that the location of this/these airport(s) is different and the calculated emissions are different compared to the original ones.",
        },
        JOURNEY: {
            DROPPABLE_DISABLED_MOVING_GROUP: "Group of {{activity}} cannot be moved here, because their duration would exceed/go below the journeys duration.",
            DROPPABLE_DISABLED_HOTEL_JOURNEY_LAST_DAY: "Cannot move hotel here because hotel stays are overnight. Please extend the journey by one day.",
            ARROW_DOWN_HOTEL_ACTIVITY_DISABLED: "Hotel cannot be moved down by one day because hotel stays are overnight. Extend the trip by one day.",
            ARROW_DOWN_HOTEL_DAY_DISABLED: 'Day cannot be moved down as there is at least one hotel in the day. Hotel stays are overnight. Please extend the trip by one day.',
            ARROW_DISABLED_CAR_BUS_WITH_ROUTE_AT_DAY: 'Day cannot be moved because there is at least one car with a given route in it. Travel Components of type car/bus that have a route must always be moved by the group.',
            ADD_HOTEL_ACTIVITY_LAST_JOURNEY_DAY: 'An accommodation cannot be added on the last day of the journey because accommodations are always overnight.',
            HOTEL_DATES_REMOVED: "Your journey has no exact dates, but your original hotel stay has exact dates. The dates of the hotel stay have been replaced with the number of nights.",
            FLIGHT_CO2_KG_E_DEPENDS_ON_DATE: "The emissions of this Travel Component depend on the date. If you move the Travel Component to another date, the calculated emissions might change.",
            FLIGHT_WITH_FLIGHT_NUMBER_JOURNEY_WITHOUT_DATES: "Your journey has no exact dates, but your original flight has a flight date. The flight date has been automatically removed.",
            CAR_BUS_REDUCED_TO_ONE_DAY: "Your original car Activity has a duration of more than one day. The duration has been reduced to one day.",
            CAR_BUS_ROUTE_REMOVED: "Your original car Activity has a route. The route has been removed.",
        },
        SETTINGS: {
            ADD_EMAIL: "Please add email",
            ADD_FIRST_NAME: "Please add first name",
            ADD_LAST_NAME: "Please add last name",
            NO_EXPEDIENT: "You can create an agency without adding expedients to it. You can add expedients afterwards via the settings.",
            IS_ADMIN: "If you make an user an admin, this user can create and delete users, edit the agency's information and change the logo of the agency.",
            ASPECT_RATIO_LOGO: "The logo you have selected does not have optimal dimensions. Ideally, your agency logo should be square.",
        },
        FLIGHT: {
            RETURN_FLIGHT_SPLIT: "The return flight will automatically be split into two flights when adding it to day {{day}}.",
            RETURN_FLIGHT_FLIGHT_NUMBER: "The return flight usually has a different flight number. If you do not specify the return flight separately, this may lead to an inaccurate calculation of the emissions."
        },
    },
    TOASTS: {
        SUCCESS: {
            CAR_DATA_VIA_ACRISS_CODE: "Car data successfully found via Acriss code.",
            CREATE_BUNDLE: "Data saved.",
            UPDATE_USER_SUCCESS_ADMIN: "Expedient successfully edited.",
            MAKE_USER_AGENCY_ADMIN: "Expedient is now agency admin.",
            UNMAKE_USER_AGENCY_ADMIN: "Expedient is no longer agency admin.",
            ADD_COMPANY: "Company added successfully.",
            ADD_AGENCY: "Agency added successfully.",
            EDIT_AGENCY: "Agency edited successfully.",
            EDIT_COMPANY: "Company edited successfully.",
            INVITE_COMPANY_ADMIN: "Email to company admin was send.",
            INVITE_USER: "Expedient invited successfully. An email was send with further instructions.",
            DELETE_USER: "Expedient deleted.",
            DELETE_AGENCY: "Agency deleted successfully.",
            UPLOAD_AGENCY_LOGO: "Agency logo uploaded successfully.",
            DELETE_AGENCY_LOGO: "Agency logo deleted successfully.",
            CHANGE_USERS_AGENCY: "Expedient successfully assigned to different agency.",
            SEND_PASSWORD_RESET_EMAIL: "We have sent you an email. Follow the instructions in the email to set a new password.",
            UPDATE_USER_SELF: "You successfully edited your data.",
            HOTEL_FOUND_VIA_GIATA_ID: "Hotel with GIATA-ID found.",
            GETTING_FLIGHTS_VIA_NUMBER_AND_DATE: "The flight was found and automatically added.",
            HOTEL_FOUND_VIA_GIATA_ID_REPLACED_PREVIOUS: "If needed we have replaced your previous values for Hotel, Country, City and Stars.",
            REPLACED_AIRPORT_SINGULAR: "We have corrected the previously entered airport to match the flight number and flight date.",
            FLIGHT_NUMBER_REMOVED_DIFFERENT_AIRPORT: "The flight number of the previous leg was removed, because arrival airport and departure airport do not match.",
            REPLACED_AIRPORT_PLURAL: "We have corrected some of the previously entered airports to match the flight number and flight date.",
            UNDO_DELETE_ACTIVITY_FROM_JOURNEY: 'Add {{activity}} back to journey.',
            UNDO_DELETE_ACTIVITY_FROM_TRAVEL_COMPONENTS_TABLE: 'Add {{activity}} back to Travel Components.',
            UNDO_DELETE_DAY_FROM_JOURNEY: 'Add day {{day}} back to journey.',
            ACTIVITY_ADDED_TO_TRAVEL_COMPONENTS: '{{activity}} added to Travel Components.',
            ACTIVITY_ADDED_TO_JOURNEY: '{{activity}} added to journey.',
            UPDATE_BUNDLE: "Data updated.",
            DELETE_BUNDLE: "Data deleted.",
            RESEND_INVITATION_EMAIL: "Invitation resent to {{email}} again.",
            TRAVEL_COMPONENTS_COPIED_TO_CLIPBOARD: "Travel Components copied to your clipboard.",
            JOURNEY_COPIED_TO_CLIPBOARD: "Journey copied to your clipboard.",
            DELETE_REMOTE_DATA: "Saved data deleted.",
            DELETE_LOCAL_DATA: "Local data cleared.",
            DELETE_SELECTED_ACTIVITIES: "Selected Travel Components were removed.",
            COMPUTED_TOTAL_PASSENGER_COUNT: "Successfully computed total passenger count for the bus category."
        },
        WARNING: {
            NO_ROUTE_FOUND: "No route could be found.",
            ROUTE_TOO_LONG: "Route to long. The maximum distance must not exceed {{maxDistance}}.",
            DIFFERENT_CO_2_ON_LOAD_BUNDLE: "The recalculated kg CO₂e values (old total: {{oldCo2KgE}}, new total: {{newCo2KgE}}) differ from the values at the time of saving the data. To update your persisted data with the new data, please save the data again.",
            MISSING_CUSTOMER: "If you provide additional customer information, you must provide at least a first name for the customer.",
            NAME_TO_SHORT: "Please enter a name that is longer than {{min}}.",
            GENERIC_MIN: "The minimum value is {{min}}.",
            GENERIC_MAX: "The maximum value is {{max}}.",
            UNDO_DELETE_ACTIVITY_FROM_JOURNEY: "Der Reisebaustein {{activity}} kann nicht mehr zur Reise hinzugefügt werden, da der Tag {{day}} nicht mehr existiert.",
            DIFFERENT_FLIGHT_WITH_FLIGHT_NUMBER_CODE_SHARING: "The flight with flight number {{flightNumber}} and new flight date {{flightDate}} is now a codeshare flight operated by a different airline. Because of the, that flight number has been removed and the emissions have been recalculated without flight number. This can lead to slightly different calculated emission results.",
            REMOVED_FLIGHT_NUMBER_ON_RECALCULATION: 'A flight with the given flight number {{flightNumber}} cannot be found for the {{date}}. Because of the, that flight number has been removed and the emissions have been recalculated without flight number. This can lead to slightly different calculated emission results.',
            DIFFERENT_FLIGHT_WITH_FLIGHT_NUMBER: "The flight with flight number {{flightNumber}} and new flight date {{flightDate}} is a different connection ({{legs}}) than your original flight. Therefore, the flight number and flight date were removed, and the emissions were calculated without them. This can lead to slightly different calculated emission results.",
            GETTING_FLIGHTS_VIA_NUMBER_AND_DATE_NO_FLIGHTS_FOUND_NO_AIRPORTS_IN_UI: "No flight could be found with the date and flight number entered. Please enter the departure and arrival airports instead.",
            GETTING_FLIGHTS_VIA_NUMBER_AND_DATE_NO_FLIGHTS_FOUND_AIRPORTS_IN_UI: "No flight could be found with the date and flight number entered. You can search with the airports instead.",
        },
        ERROR: {
            MAPBOX_ADDRESS_TO_LONG: "The address you entered is too long. Please enter an address that is shorter than {{maxLength}} characters.",
            NO_EMISSION_ON_LOAD: "The emission values for your data could not be calculated. The data was still loaded.",
            NO_EMISSION_DATA_AT_ALL_ON_LOAD: "The emission values for your data could not be calculated. Additionally, there were no calculated emission values at all in your saved data. Consider checking your data.",
            NO_RESULT_FLIGHT_NUMBER_AND_DATE: "We were unable to verify if a flight with flight number {{flightNumber}} and new flight date {{flightDate}} exists. This may result in an inaccurate emissions calculation",
            ACTIVITY_MOVED_EMISSIONS_NOT_CALCULATED: "Emissions for the activity depend on the date of the activity. No emissions could be calculated for the new date.",
            READ_BUNDLE: "Data could not be loaded.",
            LOAD_BUNDLE: "Data could not be loaded.",
            CREATE_BUNDLE: "Data could not be saved.",
            UPDATE_USER_SELF: "Your data could not be edited.",
            UPDATE_USER_ADMIN: "User could not be edited.",
            MAKE_USER_ADMIN: "Expedient could not be made to agency admin.",
            UNSET_USER_ADMIN: "Expedient could not be revoked the admin rights.",
            ADD_COMPANY: "Company could not be added. Please try again.",
            EDIT_COMPANY: "Company could not be edited.",
            ADD_AGENCY: "Agency could not be added. Please try again.",
            EDIT_AGENCY: "Agency could not be edited.",
            INVITE_COMPANY_ADMIN: "The email to the company admin could not be send.",
            INVITE_COMPANY_ADMIN_ALREADY_MEMBER: 'The expedient is already a member of the TravelDatabase',
            INVITE_COMPANY_ADMIN_COMPANY_EXISTS: 'This company already exists',
            INVITE_USER: "Invitation could not be send.",
            INVITE_USER_DEACTIVATED: "Invitation not send. The expedient already exists, but is deactivated. Please contact the KlimaLink support to activate the user.",
            DELETE_USER: "Failed to delete user.",
            DELETE_AGENCY: "Could not delete agency.",
            UPLOAD_AGENCY_LOGO: "Agency logo could not be uploaded.",
            DELETE_AGENCY_LOGO: "Agency logo could not be deleted.",
            CHANGE_USERS_AGENCY: "Expedient could not be assigned to the new agency.",
            SEND_PASSWORD_RESET_EMAIL: "Email could not be sent.",
            RESEND_INVITATION_EMAIL: "Invitation email could not be sent to {{email}} again.",
            GETTING_FLIGHTS_VIA_NUMBER_AND_DATE: "Something has gone wrong. Please try again or enter the departure and arrival airports instead of the flight number and flight date.",
            PARTIAL_OR_COMPLETE_CALCULATION: "You can still use the service, but no CO₂ e will be displayed for this service.",
            GETTING_FLIGHTS_CODE_SHARING_FLIGHT: "Unfortunately, this flight is a code share flight operated by another airline. Please search with the departure and arrival airports or flight number of the operating airline instead.",
            HOTEL_NIGHTS_EXCEED_JOURNEY_DAYS: "Your journey has a duration of {{days}} days and you try to change the hotel stay to {{nights}} nights. Please extend the duration of your journey.",
            NO_AGENCY_PDF: "You are not assigned to an agency. Please create an agency to create a PDF.",
            NO_AGENCY_SAVE: "You are not assigned to an agency. Please create an agency to save your data",
            UPDATE_BUNDLE: "Data could not be updated.",
            DELETE_BUNDLE: "Data could not be deleted.",
            GENERAL: "Oops... Unfortunately a technical error occurred.",
            LUF_NO_ACCESS_RIGHTS: "You do not have access rights to download the lookup files.",
            VALIDATE_ACRISS_CODE: "Acriss code could not be validated",
            COMPUTED_TOTAL_PASSENGER_COUNT: "Total passenger count could not be computed for the bus category.",
            WRONG_ACRISS_CODE: "Acriss code wrong",
            CAR_PROPS_ACRISS_CODE: "Car data could not be updated via Acriss code",
            HOTEL_NOT_FOUND: "Hotel not found.",
            ROUTE: "Route could not be calculated",
            EMISSIONS_NOT_CALCULATED_JOURNEY: 'The emissions of the Travel Component {{activityType}} could not be calculated.',
            GET_ADDRESS_WITH_COORDINATES: "Oops... Unfortunately a technical error occurred. Please try again.",
            VEHICLE_TYPE_CAR_NO_DATA: "Please either provide fuel consumption and/or the vehicle category and/or the acriss code.",
            VEHICLE_TYPE_BUS_NO_DATA: "Please either provide fuel consumption and/or the vehicle category.",
            VEHICLE_TYPE_BUS_MISSING_DATA: "Please provide either the vehicle category or the total passenger count along with the fuel consumption.",
            FUEL_CONSUMPTION_NO_FUEL_TYPE: "If you provide fuel consumption, you must provide a fuel type.",
            DELETE_REMOTE_DATA: "Saved data could not be deleted.",
            GET_ROUTE_FROM_COORDINATES: "Could not find route.",
            USER_EXISTS: "An expedient with this email already exists.",
            TOO_MANY_AGENCIES_INVITATION: "Cannot resend invitation email to {{email}} because user is in more than one agency.",
        }
    },
    TOOLTIP: {
        TRAVEL_COMPONENTS: {
            EDIT_CUSTOMER_INFORMATION: "Edit customer information",
            SAVE_TRAVEL_COMPONENTS: "Save Travel Components",
            LOAD_TRAVEL_COMPONENTS: "Load Travel Components",
            DELETE_REMOTE_DATA: "Permanently delete saved travel components",
            ADD_TO_JOURNEY: "Add to journey",
            CLEAR_TABLE: "Clear Travel Components table",
            DELETE_SELECTED_ACTIVITIES: "Delete selected Travel Components"
        },
        FLIGHT: {
            MAX_STOPOVERS: "Cannot add more than {{maxStopovers}} airports.",
            REMOVE_STOPOVER: "Remove stopover",
        },
        SETTINGS: {
            RESEND_INVITATION_EMAIL: "Resend invitation email to {{email}}.",
            CHANGE_PASSWORD: "We have sent an email to your registered email address with instructions on how to change your password.",
            MAKE_ADMIN: "Make expedient to agency admin.",
            MAKE_ADMIN_KLIMALINK: "Make expedient to agency admin for agency {{agency}}.",
            REMOVE_ADMIN: "Remove agency admin rights.",
            REMOVE_ADMIN_KLIMALINK: "Remove agency admin rights for agency {{agency}}.",
            RESEND_INVITATION_EMAIL_ALREADY_REGISTERED: "Expedient has completed the registration process. An new invitation is not possible.",
            EDIT_USER: "Edit expedient",
            IS_ADMIN: "If you make an user an admin, this user can create and delete users, edit the agency's information and change the logo of the agency.",
            EDIT_AGENCY: "Edit agency",
            DELETE_AGENCY: "Delete agency",
            DELETE_USER: "Delete user",
            DELETE_COMPANY: "Delete company",
            EDIT_COMPANY: "Edit company",
            CHANGE_USERS_AGENCY: "Change agency",
            DELETE_KLIMALINK_ADMIN: "KlimaLink admins cannot be deleted.",
            CHANGE_AGENCY_KLIMALINK_ADMIN: "KlimaLink admins cannot be assigned to other agencies.",
            MAKE_UNMAKE_AGENCY_ADMIN_KLIMALINK: "Agency admin rights cannot be changed for KlimaLink admins.",
            MAKE_UNMAKE_AGENCY_ADMIN_COMPANY_ADMIN: "You can't revoke agency admin rights from a company admin, because company admins are automatically assigned to every agency as agency admins.",
            EDIT_OTHER_ADMIN: "Ein anderer Agenturadmin kann nur von einem Company Admin bearbeitet werden.",
            DELETE_OTHER_ADMIN: "Ein anderer Agenturadmin kann nur von einem Company Admin gelöscht werden.",
            CHANGE_AGENCY_OTHER_ADMIN: "Ein Agenturadmin kann nicht einer anderern Agentur zugeordnet werden.",
            UNMAKE_OTHER_AGENCY_ADMIN: "Ein Agenturadmin kann nur von einem Company Admin zu einem 'normalen' Agenturmitglied gemacht werden.",
            MAKE_AGENCY_ADMIN_COMPANY_ADMIN: "Nur Company Admins können Expedient_innen zu Agenturadmins machen.",
            CHANGE_AGENCY_IS_AGENCY_ADMIN: "Expedient_in ist Agenturadmin. Wenn Sie die Agenturzugehörigkeit ändern wollen, entziehen Sie vorher die Adminrechte.",
            CHANGE_AGENCY_IS_COMPANY_ADMIN: "Expedient_in ist Firmenadmin. Firmenadmins sind jeder Agentur automatisch zugehörig.",
            CHANGE_AGENCY_ADMIN_IS_COMPANY_ADMIN: "Expedient_in ist Firmenadmins. Firmenadmins sind automatisch Agenturadmins.",
            DELETE_COMPANY_ADMIN: "Delete company admin. All Agencies and expedients realted to the company will be deleted too. The data will be preserved.",
            CHANGE_USERS_AGENCY_NOT_POSSIBLE_COMPANY_ADMIN: "Cannot change Agency, because the expedient is company admin. Company admins are part of every agency.",
            CANNOT_INVITE_USERS_ON_NOT_PRODUCTION: "New members can only be invited on the production instance.",
            INVITE_USERS_ON_STAGING: "New member can only be invited on the production instance (https://b2b.klimalink.org/travel-database). It might take a few minutes until the new member can use the test instance (https://b2b.dev.klimalink.org/travel-database).",
            CANNOT_CREATE_AGENCIES_ON_NOT_PRODUCTION: "New agencies only be created on the production instance (https://b2b.klimalink.org/travel-database). It might take a few minutes for the new agency to be available on the test instance (https://b2b.dev.klimalink.org/travel-database).",
            CREATE_AGENCIES_ON_STAGING: "When creating new agencies on the staging instance, these agencies won't be able to available on the production instance.",
            DISABLED_FUNCTIONALITY_DEV_INSTANCE: "This functionality is only available on the production instance.",
            EDIT_PERSONAL_DATA: "Edit personal data",
            USER_DEACTIVATED: "This user is deactivated.",
            EDIT_GENERAL_ON_STAGING: "Changes you do here won't be available on the production instance.",
        },
        COMMON: {
            DISABLED_FUNCTIONALITY_DEV_INSTANCE: "This function is only available on the production instance.",
            MAINTENANCE: "Currently disabled due to maintenance",
            CREATE_AGENCY_PDF: "Please create an agency to export your data.",
            CRETE_AGENCY_SAVE_BUNDLE: "Please create an agency to save your data.",
            DELETE_LOCAL_DATA: "Delete data only local",
            EDIT_TRAVEL_COMPONENT: "Edit Travel Component",
            NO_TRAVEL_COMPONENTS: "No Travel Components yet",
            COUNT_TRAVEL_COMPONENTS_SINGULAR: "{{count}} Travel Component added",
            COUNT_TRAVEL_COMPONENTS_PLURAL: "{{count}} Travel Components added",
            NO_DATA_JOURNEY: "No Travel Components in journey yet",
            COUNT_DAYS_SINGULAR: "{{count}} day in journey",
            COUNT_DAYS_PLURAL: "{{count}} days in journey",
            BETA: "This is a beta version. Some functionality might not work completely flawless. Furthermore, calculated emissions values can be wrong! If you have any feedback or suggestions, please send them to info@klimalink.org.",
            DRAG_AND_DROP: "Move Travel Component via Drag and Drop",
            MOVE_ONE_DAY_UP: "Move Travel Component one day up",
            MOVE_ONE_DAY_DOWN: "Move Travel Component one day down",
            MOVE_ALT_KEY: "Hold Alt-Key to move one Travel Component from the group.",
            DELETE_ALT_KEY: "Hold Alt-Key to delete one Travel Component from the group.",
            EDIT_ALT_KEY: "Hold Alt-Key to edit one Travel Components from the group.",
            DELETE_TRAVEL_COMPONENT: "Delete Travel Component",
            CREATE_PDF: "Create PDF",
            COPY_JOURNEY_TO_CLIPBOARD: "Copy journey to clipboard",
            COPY_TRAVEL_COMPONENTS_TO_CLIPBOARD: "Copy Travel Components to clipboard",
            CALENDAR_DEACTIVATED_JOURNEY_NO_DATES: "You cannot choose a Date, because your journey has no exact date."
        },
        ACTIVITY_FLIGHT: {
            REMOVE_STOPOVER: "Remove stopover",
            RETURN_FLIGHT: "Return flight",
            ROUNDTRIP_SINGULAR: "Round-trip",
            ADD_STOPOVER_DISABLED_EDIT: "You cannot add a stopover when you edit a flight",
            REMOVE_STOPOVER_DISABLED_EDIT: "You cannot remove a stopover when you edit a flight",
            OWN_AIRPORT_TRANSFER_DISABLED_EDIT: "You cannot change this value when you edit a flight"
        },
        ACTIVITY_HOTEL: {
            CHOOSE_DATES: "Choose dates",
        },
        JOURNEY: {
            MOVE_CAR_BUS_ACTIVITY_WITH_ROUTE: "This car Travel Component has a route and is longer than one day. Because of that, it can only be moved in a group.",
            DELETE_REMOTE_DATA: "Permanently delete saved journey",
            GROUP_DURATION: "{{activity}} at day {{days}}",
            DELETE_DAY: "Delete day",
            ADD_DAY: "Add day",
            SAVE_JOURNEY: "Save journey",
            LOAD_JOURNEY: "Load journey",
            MOVE_DAY_UP: "Move day up",
            MOVE_DAY_DOWN: "Move day down",
            CALCULATE_NEW_ACTIVITY: "Calculate new Travel Component",
            ADD_ACTIVITY_FROM_TRAVEL_COMPONENT_TABLE: "Add Travel Component from Travel Component Table",
            REMOVE_EXACT_DATES: "Remove exact dates from journey",
            MOVE_WHOLE_GROUP: "You move the whole group of {{activityType}}",
            DELETE_WHOLE_GROUP: "You move the whole group of {{activityType}}",
            EDIT_WHOLE_GROUP: "You edit the whole group of {{activityType}}",
            CHANGE_JOURNEY_DURATION_BLOCKED_DELETE_DAY: "The duration of the journey cannot be changed while deleting a day. Please wait for the 'Add day back to journey' message to disappear.",
            ARROW_GROUP_EXCEEDS_JOURNEY_DURATION: "Group of {{activity}} cannot be moved, because it would exceed the journeys duration.",
            ARROW_ACTIVITY_EXCEEDS_JOURNEY_DURATION: "Travel Components {{activity}} cannot be moved, because it would exceed the journeys duration.",
            ALT_KEY_PRESSED_MOVE_GROUP: "Move {{activity}} from the whole group of.",
            ALT_KEY_PRESSED_DELETE_GROUP: "Move whole group of {{activity}}",
            ALT_KEY_PRESSED_EDIT_GROUP: "Edit whole group of {{activity}}",
            DELETE_CAR_BUS_ROUTE_GROUP: "Car can only be deleted in whole group, because it has a route.",
            EDIT_CAR_BUS_ROUTE_GROUP: "Car can only be edited in whole group, because it has a route.",
            CLEAR_JOURNEY: "Clear journey",
        },
        SITE_TITLE: {
            DELETE_CUSTOMER: "Delete customer"
        },
        CAR_BUS: {
            PERSON_COUNT_CALCULATION_HINT: "Count of persons, for which emissions are calculated",
            TOTAL_PASSENGER_COUNT: "Total count of passenger, that sit in the bus",
            MAX_NUMBER_WAYPOINTS: "You have reached the max number of {{maxNumber}} waypoints",
            DELETE_WAYPOINT: "Delete waypoint",
            REMOVE_ADDRESS: "Remove address",
            SELECT_STOP_FROM_MAP: "Select stop from map",
            CALCULATED_DISTANCE_OVERWRITTEN: "You have manually entered a distance. This overrides the distance calculated based on the entered route",
            IS_HYBRID_DEACTIVATED_ACRISS_CODE: "You have entered an Acriss code which is a hybrid vehicle. You cannot change this selection.",
            IS_HYBRID_DEACTIVATED_FUEL_TYPE: "You have selected electrict as fuel type. You cannot change this selection.",
        },
    },
    LABELS: {
        TRAVEL_COMPONENTS: {
            GENERAL_INFORMATION_ON_FORM: "Save Travel Component Dialogue",
            INFORMATION: 'Enter information to save the Travel Components',
            SELECT_TRAVEL_COMPONENT: "Selected Travel Component",
            UPDATE_OR_SAVE_TRAVEL_COMPONENTS: "Update or save Travel Components anew",
            ADD_TO_JOURNEY: "Add {{activity}} to journey",
        },
        CUSTOMER: {
            GENERAL_CUSTOMER_INFORMATION: "Enter optional general customer information",
            DETAILED_CUSTOMER_INFORMATION: "Enter or edit optional detailed customer information"
        },
        SETTINGS: {
            KLIMALINK_ADMINISTRATION: "Klimalink administration: Invite new company admin",
            TAC_CHECKBOX: "I accept the general terms and conditions",
            CREATE_AGENCY: "Create new agency",
            CREATE_COMPANY: "Create new company",
            AGENCY_NAME_AND_EMAIL: "Agency name und agency email",
            COMPANY_NAME_AND_EMAIL: "Company name and company email",
            IS_MEMBER: "Is KlimaLink member?",
            CHOOSE_USERS_AGENCY: "Users agency",
            CHOOSE_USERS_AGENCY_ADMIN: "Agency where user is admin",
        },
        JOURNEY: {
            GENERAL_INFORMATION_ON_FORM: "Create journey dialogue",
            INFORMATION: 'Enter information to create the journey',
            CREATE_JOURNEY: 'Assign Travel Components to days',
            NUMBER_NIGHTS: "Number of nights",
            UPDATE_OR_SAVE_JOURNEY: "Update journey or save journey anew",
        },
        FLIGHT: {
            NUMBER_FLIGHT_PERSONS_RETURN: 'Number of flights, Number of passangers, Return flight yes/no'
        },
        COMMON: {
            NUMBER_PERSONS: "Number of persons",
            NUMBER_NIGHTS: 'Number of nights',
            ADD_ACTIVITY: "Add Travel Component",
            BUNDLE_SAVE: "Save new",
            BUNDLE_UPDATE: "Update existing data",
            SELECT_AGENCY: "Agentur auswählen"
        },
        HOTEL: {
            MEAL_PLAN: 'Please choose the type of meals.',
        },
        CAR_BUS: {
            HYBRID: "Hybrid",
            FIRST_WAYPOINT: "Start",
            LAST_WAYPOINT: "Destination",
            WAYPOINT: "Stopover",
            ENTER_CAR_AND_ROUTE_INFORMATION: "Enter vehicle and route information",
            VEHICLE_TYPE: "Vehicle Type",
            FUEL_TYPE: "Fuel Type",
            FUEL_CONSUMPTION: "Fuel Consumption ({{unit}})",
            CAR_CATEGORY: "Car Category",
            ACRISS_CODE: "Acriss Code",
            FIRST_LAST_CHARACTER: "Only first & last character",
            CAR_BUS_CATEGORY: "Vehicle Category",
            COUNT_DAYS: "Days",
            COUNT_PERSONS: "Persons",
            TOTAL_PASSENGER_COUNT: "Total Passenger Count",
            DISTANCE_KM: "Distance (km)",
            DAYS_OF_USE_NUMBER_PASSENGERS: "Days of use, Number of passangers",
            MAP_STYLE: "Map style",

        }
    },
    NAVIGATION: {
        STATISTIC: "Statistics",
        JOURNEYS: "Journeys",
        JOURNEY: "Journey",
        TRAVEL_COMPONENTS: "Travel Components",
        HOME: "Calculate CO₂e",
        ADMINISTRATION: "Administration",
        SETTINGS: "Settings",
        LOGO_ALT: "KlimaLinkLogo of company"
    },
    SCREENS: {
        HELP: {
            TITLE: "We're here to help you!",
            IFRAME_TITLE: "Manual for the B2B Platform",
        },
        JOURNEY: {
            NAME: "Name of Journey",
            INITIAL_GROUP_TITLE: "All Travel Components",
            NO_DAY_TEXT: 'You do not have a day in your journey',
            ADD_DAY_BUTTON: "Add day",
            ACTIVITY_EXCEEDS_JOURNEY_DURATION: "Activity duration exceeds journey duration",
            ACTIVITY_PERSON_COUNT_EXCEEDS_JOURNEY_PERSON_COUNT: "Person count exceeds journeys person count",
        },
        CREATE_AGENCY_INVITE_USERS: {
            COMPLETE_FAIL_INVITE_USER: "Expedients could not be invited. Don't worry, you can invite expedients in the menu 'Settings'.",
            INVITE_USERS: {
                HEADLINE: "Invite expedients",
                ADD_EXPEDIENT_BUTTON: 'Invite another expedient',
                REMOVE_EXPEDIENT_BUTTON: 'Remove expedient',
            }
        },
        TERMS_AND_CONDITIONS: {
            COMPANY_ADMIN: {
                TITLE_WITH_ACCEPT: "Please accept our terms and conditions",
                TITLE_WITH_WITHOUT_ACCEPT: "Our terms and conditions",
            },
            NORMAL_USER: {
                TITLE: 'Terms and Conditions',
                HINT: 'Currently you cannot use the KlimaLink travel database because your company admin has not yet accepted the General Terms and Conditions.'
            },
        },
        NO_ROUTE: {
            TITLE: 'Hoops, nothing to see here...'
        },
        REGISTRATION: {
            REGISTRATION_COMPLETE_MESSAGE: "Registration successful",
            CREATING_AGENCY_MESSAGE: "Agency is created...",
            INVITING_USERS_MESSAGE: "Invitation email is being sent to expedients...",
            COMPANY_USER_TITLE: 'Please complete your details to finalise your registration for KlimaLink, the Travel Footprint Database',
            AGENCY_USER_TITLE: "Please create an agency and invite expedients",
            GIVEN_INFORMATION_TITLE: "Already given information",
            MISSING_USER_INFORMATION_TITLE: "Add missing user information for {{userName}} ({{email}})",
            COMPANY_ADMIN: {
                MISSING_COMPANY_INFORMATION_TITLE: "Add missing company information for {{company}}",
            },
        },
        SETTINGS: {
            MENU: {
                ADMIN_SETTINGS: "Admin Settings",
                USER_SETTINGS: "Personal Settings",
                KLIMALINK_SETTINGS: "KlimaLink Settings",
            },
            SEARCH_BAR_LABEL_MEMBERS: "Search for members (it's only possible to search last name of expedients)",
            SEARCH_BAR_LABEL_MEMBERS_AGENCIES: "Search for agencies (it's not possible to search for first - or last name of expedients)",
            SEARCH_BAR_LABEL_AGENCIES: "Search for agencies (it's not possible to search with company names)",
            NO_AGENCY_HINT_ADD_USERS: "Please create an agency to invite expedients.",
            NO_AGENCY_HINT_ADD_LOGO: "Please create an agency. Only then can you upload an agency logo.",
            NO_AGENCY_HINT_USER_SETTINGS: "Currently you are not belonging to any agency.",
            INVITE_COMPANY_ADMIN: "Invite company admin to KlimaLink",
            AMI_I_AGENCY_ADMIN: "Am I agency admin?",
            TITLE: "Settings",
            PERSONAL_DATA: "Personal data",
            USER_SETTINGS_AGENCY_TITLE: "Agency I am assigned to",
            USER_SETTINGS_AGENCIES_TITLE: "My agencies",
            DELETE_USER: "Delete expedient {{user}}?",
            DELETE_USER_TEXT: "Do you really want to delete {{user}}? Then {{user}} can no longer use the KlimaLink Travel Footprint Database. However, the data saved by {{user}} will be retained.",
            DELETE_USER_KLIMALINK_TEXT: "Do you really want to delete {{user}}? {{user}} can no longer use the KlimaLink Travel Footprint Database. However, the data saved by {{user}} will be retained. {{user}} is in the following agencies: {{agencies}}.",
            DELETE_COMPANY_ADMIN_KLIMALINK_TEXT: "{{user}} is a company admin.",
            DELETE_AGENCY_TEXT: "Are you sure you want to delete {{agency}}? All expedients associated with {{agency}} will also be deleted. All data saved by the expedients of {{agency}} will also be deleted.",
            DELETE_OWN_AGENCY_TEXT: "Because you are deleting the agency you are member of, your account will be deleted too.",
            DELETE_COMPANY_TEXT: "Are you sure you want to delete {{company}}? All agencies and expedients associated with {{company}} will also be deleted. All data saved by the expedients of {{company}} will also be deleted. Your own account will also be deleted.",
            DELETE_AGENCY: "Delete Agency {{name}}",
            DELETE_COMPANY: "Delete Company {{name}}",
            EDIT_USER: "Edit expedient {{name}}",
            EDIT_USER_PERSONAL: "Edit personal data",
            ADD_NEW_USER: "New expedient",
            ADD_NEW_USER_FAIL: "User could not be added.",
            ADD_NEW_AGENCY: "New agency",
            ADD_NEW_COMPANY: "New company",
            COMPANY_TITLE: "Company",
            AGENCIES_TITLE: "Agencies",
            IS_ADMIN_LABEL: "Agency Admin",
            USERS_TITLE: "Expedient_innen",
            USERS_COUNT: "Number of travel agents",
            CHANGE_PASSWORD_LABEL: "Change password",
            CHANGE_PASSWORD_REQUEST_EMAIL: "Request email",
            CHANGE_PASSWORD_EMAIL_SEND: "Email send",
            EDIT_AGENCY: "Edit agency",
            EDIT_COMPANY: "Edit company",
            ADD_LOGO: "Agency logo",
            ADD_LOGOS: "Agency logos",
            NO_LOGO_UPLOADED_YET: "No logo uploaded yet.",
            TELEPHONE_NUMBER_WITH_AREACODE: "Telephone number with area code",
            FILE_NAME: "File name",
            COUNTRY_CODE_LABEL: "Country code",
            DROP_LOGO_HOVER: "Drop logo here",
            DROP_LOGO_TEXT: "Upload or drop a file right here. Ideally 200x200px.",
            LOGO_UPLOADED_SUCCESS: "Uploaded the following file",
            COUNTRY_LABEL: "Land",
            AGENCY_NAME_ALREADY_GIVEN: "The agency name {{agencyName}} is already in use. Please use another one.",
            USER_REGISTRATION_NOT_COMPLETED: "Registration not complete",
            INVITE_CONTACT_PERSON: 'Do you want to invite the {{contactPerson}} to the TravelDatabase?',
            MAKE_CONTACT_PERSON_AGENCY_ADMIN: 'Do you want to make the {{contactPerson}} to an agency admin?',
            ADD_SECOND_CONTACT: 'Add second contact person',
            ADD_USER_EMAIL_ALREADY_IN_USE: "Cannot add user. This email ({{email}}) is already in use.",
            USER_PREFERENCES: {
                TITLE: "Personalisation",
                SHOW_GIATA_ID_FIELD_TEXT: "Would you like to be able to search for hotels with a GIATA-ID?",
                SHOW_GIATA_ID_FIELD_LABEL: "Show GIATA-ID field",
            },
        },
        AUTHENTICATING_USER: {
            TEXT: "KLimaLink is authenticating you..."
        },
        COMMON: {
            ADD_ACTIVITY_TO_JOURNEY: "Add {{activity}} to journey on day {{day}}",
            ADD_ACTIVITY_TO_TRAVEL_COMPONENTS_TABLE: 'Add {{activity}} to Travel Components Table',
            GO_TO_TRAVEL_COMPONENTS: "Go to Travel Components",
            GO_TO_JOURNEY: 'Go to Journey',
            BUTTON_BOTTOM_ACTIVITY: {
                SECOND_BUTTON_ADD: "Add to {{type}}, add different",
                SECOND_BUTTON_UPDATE: "Update in {{type}}, add different",
                THIRD_BUTTON_ADD: "Add to {{type}}",
                THIRD_BUTTON_UPDATE: "Update in {{type}}",
                FOURTH_BUTTON_ADD: "Add to {{type}}, request again",
                FOURTH_BUTTON_UPDATE: "Update in {{type}}, request again",
            }
        },
        SELECT_TRAVEL_COMPONENTS: {
            SITE_TITLE: "Query Travel Components",
            SEARCH_BAR_LABEL: "Search for travel components"
        },
        HOME: {
            SITE_TITLE: "Welcome {{name}} to the Travel Footprint Database",
        },
        CREATE_JOURNEY: {
            SITE_TITLE: "Create journey",
            JOURNEY_NUMBER: "Journey number",
            NO_AGENCY: "In order to create a journey, you have to create an agency."
        },
        HOTEL: {
            HOTEL_INFO: "Hotel info",
            STAY_INFO: "Stay info",
            GIATA_ID: "GIATA-ID",
            SEARCH: "Optional",
            HOTEL_NAME: "Hotel name",
            SEARCH_HOTEL_NAME: "Optional",
            PROPERTY: "Property",
            CITY: "City",
            SEARCH_CITY: "City",
            REGION: "Region",
            COUNTRY: "Country",
            SEARCH_COUNTRY: "Country",
            ROOM_CATEGORY: "Room category",
            ROOM_CATEGORY_SS: "SG",
            ROOM_CATEGORY_DS: "DG",
            ROOM_CATEGORY_SP: "SGComf",
            ROOM_CATEGORY_DP: "DGComf",
            ROOM_CATEGORY_S: "Suite",
            ROOMS: "Rooms",
            MEAL_PLAN: "Meal plan",
            MEAL_CLASS_OV: "RO",
            MEAL_CLASS_ÜF: "BB",
            MEAL_CLASS_HP: "HB",
            MEAL_CLASS_VP: "FB",
            MEAL_CLASS_AI: "AI",
            PEOPLE: "People",
            NIGHTS: "Nights",
        },
        TRAVEL_OPTIONS_OVERVIEW: {
            SITE_TITLE: "Travel Components",
            ADD: "Add more travel components"
        },
        TRAVEL_COMPONENTS_OVERVIEW: {
            CREATE_JOURNEY: "Create journey",
            LOAD_TRAVEL_COMPONENTS: "Load Travel Components",
            RADIO_BUTTON_GROUP: "Select agency",
            ADD_TRAVEL_COMPONENTS: "Add travel components",
            NO_TRAVEL_COMPONENTS: "You have not added any Travel Components.",
            ROOM: "room",
            ROOMS: "rooms",
            NIGHT: "night",
            NIGHTS: "nights",
        },
        CAR_BUS: {
            SELECT_VEHICLE_TYPE: "Please select a vehicle type to set car information.",
            CAR_INFORMATION: "Car/Bus Information",
            ADD_STOPOVER: "Add stopover",
            ROUTE: "Route",
            NO_ADDRESS_REVERSE_GEOCODING: "No address found, using coordinates",
            STREET: "Street",
            SATELLITE: "Satellite",
            OUTDOOR: "Outdoor",
            MAP_STYLE: "Map style",
        }
    },
    ALT: {
        KLIMALINK_LOGO: "The KlimaLink logo. An image with the words: KlimaLink - Travel Footprint Database",
        ATMOSFAIR_LOGO: "The atmosfair logo. An image with the words: Think, go climate conscious."
    },
    MODALS: {
        READ_BUNDLES: {
            UPDATING_PERSISTED_DATA_MOCK: "... updating your saved data with our most current data ...",
            CALCULATING_EMISSIONS_MOCK: "... recalculating emissions with updated data ...",
            TITLE: "Load Travel Components",
            NO_RECORDS: "No records exist for this agency",
            AGENCY_SELECTION_MESSAGE: "Select an Agency to view records",
            NO_AGENCY: "You are not assigned to an agency. Please create an agency to load Travel Components.",
        },
        REPLACE_OR_ATTACH_TRAVEL_COMPONENTS: {
            TITLE: "Replace or attach Travel Components",
            TEXT: "You have already Travel Components in your Travel Component Table and you are loading more Travel Components. Do you want to replace the already existing Travel Components with the loaded Travel Components, or do  you want to attach the loaded Travel Components to the existing Travel Components?"
        },
        REPLACE_JOURNEY: {
            TITLE: "Replace journey",
            TEXT: "You already have a journey with Travel Components and/or other journey specific data. Would you like to replace the existing journey with the newly loaded journey?",
        },
        SAVE_BUNDLES: {
            SAVE_TRAVEL_COMPONENTS_TITLE: "Save Travel Components",
            UPDATE_TRAVEL_COMPONENTS_TITLE: "Update Travel Components",
            SAVE_JOURNEY_TITLE: "Save journey",
            UPDATE_JOURNEY_TITLE: "Update journey",
            ADDITIONAL_CUSTOMER_INFORMATION: "Additional customer information",
            TRAVEL_COMPONENTS_TO_SAVE: 'Travel Components to save',
            CUSTOMER_OVERLAY_NO_AGENCY_SELECTED: 'Please select an agency before entering customer information.',
            CUSTOMER_OVERLAY_NO_AGENCY_CREATED: 'Please create an agency before entering customer information.',

        },
        CREATE_JOURNEY: {
            TITLE: "Create journey",
        },
        DELETE_BUNDLE: {
            JOURNEY_TITLE: "Delete journey",
            TRAVEL_COMPONENTS_TITLE: "Delete Travel Components",
            JOURNEY_TEXT: "Do you really want to delete the journey ({{name}}), created by {{userName}}? This cannot be undone.",
            TRAVEL_COMPONENTS_TEXT: "Do you really want to delete the Travel Components ({{name}}), created by {{userName}})? This cannot be undone."
        },
        TRAVEL_COMPONENTS: {
            TITLE: "Please select agency",
            TEXT: "You are assigned to more than one agency. Please select the agency you want to sign the PDF with.",
        },
        SETTINGS: {
            MAKE_ADMIN_TITLE: "Make {{user}} agency admin",
            UNMAKE_ADMIN_TITLE: "Withdraw agency admin rights from {{user}}",
            MAKE_UNMAKE_ADMIN_TITLE: "Change {{user}} agency admin rights",
            MAKE_UNMAKE_ADMIN_IS_ADMIN_TEXT: "Currently {{user}} is agency admin in agency {{agency}}.",
            MAKE_UNMAKE_ADMIN_TEXT: "Change the agency admin rights of {{user}}. {{user}} can only be agency admin in once agency.",
            MAKE_USER_ADMIN_TEXT: "Would you like to make {{user}} an agency admin? {{user}} can add expedients to the agency, delete the agency and edit the agency logo.",
            UNMAKE_USER_ADMIN_TEXT: "Would you like to remove {{user}}'s agency admin rights? {{user}} will then no longer be able to add or remove expedients to the agency, delete the agency or edit the agency logo.",
            CHANGE_USERS_AGENCY_TITLE: "Assign {{name}} to another agency",
            CHANGE_USERS_AGENCY_TEXT: "Currently {{name}} is in {{oldAgency}}. Would you like to change the agency affiliation of {{name}}?",
            CHANGE_USERS_AGENCY_ADMIN_TEXT: "{{name}} will lose its admin rights in the new agency. However, you can simply reassign them.",
        },
        CUSTOMER: {
            EDIT_CUSTOMER_TITLE: "Edit customer",
            CREATE_CUSTOMER_TITLE: "Create customer"
        }
    },
    ACTIVITIES: {
        CAR_BUS: {
            TITLE: "Car/Bus",
            BUS: "Bus",
            CAR: "Car",
            FUEL_TYPE: {
                DIESEL: "Diesel",
                PETROL: "Petrol",
                ELECTRIC: "Electric",
                UNKNOWN: "Unknown",
                DEFAULT: "Default"
            },
            DEFAULT: {
                DIESEL: "Diesel",
                PETROL: "Petrol",
                ELECTRIC: "Electric",
                UNKNOWN: "Unknown",
                DEFAULT: "Default"
            },
            NO_CITY: "No city",
            NO_STREET: "No street",
            NO_ADDRESS: "No address",
            CAR_CATEGORIES: {
                SMALL_CAR: "Small car",
                MIDDLE_CLASS: "Mid-range car",
                UPPER_CLASS: "Luxury class/saloon",
                SUV_JEEP: "SUV/Jeep",
                MINIBUS_CAR: "Minibus",
                MIDIBUS_CAR: "Midibus  (not available yet)"
            },
            BUS_CATEGORIES: {
                MINIBUS: "Minibus",
                MIDIBUS: "Midibus",
                CITY_BUS: "City Bus",
                REGIONAL_BUS: "Regional Bus",
                LONG_DISTANCE_COACH: "Travel Coach",
                LUXURY_COACH: "Luxury Coach"
            }
        },
        FLIGHT: {
            TITLE: "Flight",
            NAME: 'Flight',
            FLIGHT_SINGULAR: "Flight",
            FLIGHT_PLURAL: "Flights",
            ONEWAY_SINGULAR: 'One-way',
            RETURN_FLIGHT_SINGULAR: 'Return flight',
            ONEWAY_ONLY_SINGULAR: 'One-way',
            ONEWAY_PLURAL: 'One-way flights',
            ONEWAY_ONLY_PLURAL: 'One-ways',
            ROUNDTRIP_SINGULAR: 'Round-trip',
            ROUNDTRIP_ONLY_SINGULAR: 'Round-trip',
            ROUNDTRIP_PLURAL: 'Round-trip flights',
            ROUNDTRIP_ONLY_PLURAL: 'Round-trips',
            OFFSET_ENTIRE_AIRCRAFT: 'Offset entire aircraft',
            FLIGHT_TYPE: 'Flight type',
            FLIGHT_TYPE_CHARTER: 'Charter',
            FLIGHT_TYPE_LINE: 'Scheduled',
            FLIGHT_CLASS_FIRST: 'First Class',
            FLIGHT_CLASS_BUSINESS: 'Business Class',
            FLIGHT_CLASS_ECONOMY_PREMIUM: 'Premium Eco',
            FLIGHT_CLASS_ECONOMY: 'Eco',
            CALCULATION_FAILED_FOR_LEGS: "For the following legs, no emission calculation could be performed:",
            CALCULATION_SUCCESSFUL_FOR_LEGS_WITH_RETURN_FLIGHT: "Für folgende Abschnitte (Hin- und Rückflug) konnte eine Emissionsberechnung durchgeführt werden:",
            CALCULATION_SUCCESSFUL_FOR_LEGS_WITHOUT_RETURN_FLIGHT: "Für folgende Abschnitte konnte eine Emissionsberechnung durchgeführt werden:",
            CALCULATION_DONE_FOR_LEGS: "The emissions are:",
            INTRO: 'Calculate your compensateFlight’s CO₂ footprint and offsetting costs in renewable energy projects. We accept all common means of payment. You will receive a personal certificate and a German donation receipt (tax deductibility depends on regulations of your country).',
            TITLE_RESULTS: 'Emission Calculation Results',
            FLIGHT_NUMBER: "Flightnumber",
            DEPARTURE_AIRPORT: 'Departure airport',
            VIA_AIRPORT: 'Via airport',
            ARRIVAL_AIRPORT: 'Arrival airport',
            TRAVEL_CLASS: 'Travel class',
            AIRCRAFT_TYPE: 'Aircraft type',
            ADD_VIA_AIRPORT: 'Add via airport',
            FLIGHT_COUNT: 'Flights',
            CHOOSE_FLIGHTS: "Please choose the flights",
            PLACEHOLDER_AIRPORT: 'City or Airport',
            FLIGHT_DISTANCE: 'Flight distance',
            DEPARTURE_DATE: "Departure date",
            DESCRIPTION: "You can search for a connection either by departure and arrival airport or by flight number and flight date. After entering the flight number and flight date, the connection is automatically searched for and the departure and arrival airports are filled in. If no information on date, flight number or class of service is available, the emissions value is averaged from all flights on this city pair.",
            AIRPORT_TRANSFER: "Airport transfer",
        },
        TRAIN: {
            TITLE: "Train"
        },
        HOTEL: {
            TITLE: "Hotel",
            DESCRIPTION: "Should a specific hotel not be listed you can enter city, country and category to calculate an average footprint. Differing between room categories is not yet possible due to lack of data availability.",
            HOTEL_CLASS_UNKNOWN: "Unknown"
        },
        HOSTEL: {
            TITLE: "Hostel",
        }
    },
    TRAVEL_OPTIONS: {
        TRANSPORT: {
            TITLE: "Transport",
        },
        ACCOMMODATION: {
            TITLE: "Accommodation",
        },
        UNDERTAKING: {
            TITLE: "Activity",
        }
    },
    ERRORS: {
        REGISTRATION_UPDATE_USER_INFO: "Registration could not be completed. Please try again.",
        TAC_UPDATE_USER_INFO: "Terms and conditions could not be accepted. Please try again.",
        FAILED_CREATE_AGENCY_UPON_REGISTRATION: "Agency could not be created. Don't worry. You can create an agency in the menu 'Settings'",
        GENERAL_REFETCHING: "Something went wrong. Please reload the site.",
        CLICK_AWAY_AUTOCOMPLETE_QUERY: "Please select {{value}} from the list.",
        GENERAL_NETWORK_ERROR_TITLE: "General Error",
        GENERAL_NETWORK_ERROR_BODY: 'Oops... Unfortunately a technical error occurred.',
        CALCULATION_PARTIAL_FAILURE: "Partial calculation failure",
        CALCULATION_COMPLETE_FAILURE: "Complete calculation failure",
        ERROR_HINT: "If the error persists, please contact KlimaLink.",
        COMMON: {
            ACCEPT_TERMS: "Please accept the terms and conditions.",
            BASE_MIN_MAX_VALUE_EXCEEDED_MESSAGE: 'Please enter {{words}} that is greater than or equal to {{min}} and less than or equal to {{max}}.',
            MIN_MAX_PEOPLE_EXCEEDED: 'a number of people',
            MIN_MAX_DAYS_EXCEEDED: 'Please enter a number of days that is greater than or equal to {{min}} and less than or equal to {{max}}.',
            MIN_MAX_TOTAL_PASSENGER_COUNT_EXCEEDED: 'a total passenger count of bus',
            NAME: "Please enter a name.",
            STREET: "Please enter a street.",
            HOUSE_NUMBER: "Please enter a house number.",
            ZIP_CODE: "Please enter a postal code.",
            CITY: "Please enter a city.",
            COUNTRY_CODE: "Please enter a country code.",
            COUNTRY: "Please enter a country.",
            TELEPHONE_NUMBER_WITH_AREA_CODE: "Please enter a telephone number.",
            EMAIL: "Please enter an email address.",
            ADDITIONAL_ADDRESS_INFORMATION: "If you enter additional address information, this must be at least two characters long.",
            DESCRIPTION: "Please enter a Travel Component description",
            GENERAL: "Something went wrong, please try again."
        },
        SETTINGS: {
            AGENCY_USER: "Please choose an agency for the expedient.",
            FIRST_CONTACT_PERSON_FIRST_NAME: "Please enter the first name of the first contact person.",
            FIRST_CONTACT_PERSON_LAST_NAME: "Please enter the last name of the first contact person.",
            LOADING_AGENCY_LOGO: "Agency logo could not be loaded.",
        },
        FLIGHT: {
            FLIGHT_NUMBER_INVALID: "The flight number you have entered is invalid. Flight numbers consist of 1 letter and 1-4 numbers.",
            MIN_MAX_PASSENGERS_EXCEEDED: 'a number of passengers',
            SELECT_AIRPORT_FROM_LIST: 'Please specify an airport. To do this, you must select an airport from the list that opens. You cannot write out the airport completely yourself.',
            SELECT_AIRLINE_FROM_LIST: 'Please specify an airline. To do this, you must select an airline from the list that opens. You cannot write out the airline completely yourself.',
        },
        HOTEL: {
            GIATA_ID: "Please enter a GIATA-ID.",
            MIN_MAX_ROOMS_EXCEEDED: 'a number of rooms',
            MIN_MAX_NIGHTS_EXCEEDED: 'a number of nights',
        },
        CAR_BUS: {
            MIN_MAX_DISTANCE_EXCEEDED: "a distance in km",
            MIN_MAX_FUEL_CONSUMPTION_EXCEEDED: "a fuel consumption in liter",
            MIN_MAX_DAYS_EXCEEDED: 'a number of days',
            VEHICLE_TYPE: "Please select a vehicle type",
            NOT_DISTANCE_FROM_ROUTE: "The distance could not be calculated from the route. You can enter the distance manually.",
            INVALID_ACRISS_CODE: "Invalid Acriss code",
        },
        BACKEND_ERROR_CODES: {
            // Role Management
            CODE_501: "User is not an admin.",
            CODE_504: "Maximum number of companies exceeded.",
            CODE_506: 'User is already a member of the TravelDatabase.',
            CODE_508: "Agency with the same name exists already.",
            CODE_509: "Company with the same name already exists.",
            CODE_514: 'Expedient could not be added to agency. Please contact KlimaLink support.',
            CODE_518: 'Expedient was deactivated. Please contact KlimaLink support.',

            // Flight
            CODE_601: "Airport \'{{airport}}\' not found.",
            CODE_602: "Airline \'{{airline}}\' not found.",
            CODE_603: "Aircraft \'{{aircraftType}}\' not found.",
            CODE_604: "No flights found for City-Pair \'{{airports}}\'.",
            CODE_605: "Flight number and flight date not specified.",
            CODE_606: "Flight number not specified.",
            CODE_607: "Flight date not specified.",
            CODE_608: "Flight date \'{{flightDate}}\' could not be parsed.",
            CODE_609: "Flight number \'{{flightNumber}}\' could not be parsed.",
            CODE_610: "The flight is a code share flight operated by another airline. Please search with the flight number of the operating airline.",
            CODE_611: "No flights found for flight number \'{{flightNumber}}\' and flight date \'{{flightDate}}\'.",
            CODE_612: "Several city pairs were found for flight \'{{flightNumber}}\'. Please specify the desired city pair additionally.",
            CODE_613: "Several city pairs were found for the flight \'{{flightNumber}}\' on \'{{flightDate}}\'. Please specify the desired city pair additionally.",
            CODE_614: "No flights could be found for the flight \'{{airports}}\', airline \'{{airline}}\' and aircraft type \'{{aircraftType}}\'.",
            CODE_615: "No flights could be found for the flight \'{{airports}}\' and airline \'{{airline}}\'.",
            CODE_619: "The index {{index}} occurs in more than one activity.",
            CODE_620: "Number of flights is 0 or negative.",
            CODE_621: "Number of passengers is 0 or negative.",
            CODE_622: "The flight number and the flight date must be entered together (or not at all).",
            CODE_623: "Departure and arrival must be specified together (or not at all).",
            CODE_624: "Either the flight number and date or the place of departure and arrival must be specified.",
            CODE_625: "The departure and arrival airports are identical: {{departure}}, {{arrival}}.",
            CODE_627: "Required parameter missing.",
            CODE_628: "Could not get flights list with flight number and date.",

            // Car - Bus
            CODE_751: 'Fuel consumption must be a valid, positive number.',
            CODE_752: 'Distance must be a valid, positive number.',
            CODE_753: 'Number of passengers must be a valid, positive integer',
            CODE_754: 'One or more via waypoints are invalid.',
            CODE_755: 'Days of use must be a valid, positive integer.',
            CODE_757: 'Bus category must be specified to estimate fuel consumption per km when the vehicle type is bus and total fuel consumption is not provided.',
            CODE_758: 'Either Acriss code or car category must be specified to estimate fuel consumption per km when the vehicle type is car and total fuel consumption is not provided.',
            CODE_759: 'Days of use must be null when the vehicle type is bus',
            CODE_760: 'First letter of Acriss code wrong',
            CODE_761: 'Last letter if Acriss code wrong',
            CODE_762: 'First letter of Acriss code and car category wrong',
            CODE_763: 'Last letter if Acriss code and car category wrong',

            // Hotel
            CODE_701: "Number of rooms must be a valid, positive integer.",
            CODE_702: "Number of nights must be a valid, positive integer.",
            CODE_703: "Country must be a valid ISO3166 Alpha3 country code.",
            CODE_704: "Number of people must be a valid, positive integer.",
            CODE_705: "Could not get hotels by name, city and country.",

            // Request
            CODE_802: "Rate limit exceeded",
            CODE_830: "Index must be a valid, positive integer. (specified: {{index}}).",
            CODE_817: "An error occurred during the emission calculation.",

            // Fusion Auth
            CODE_906: "Your account as been deactivated. Please contact your admin if that was not intentional.",
            CODE_907: 'Company not found',
            CODE_910: 'Could not send email',
            CODE_912: 'Company admin has not accepted terms and conditions',
            CODE_917: 'Expedient was deactivated. Please contact KlimaLink support.',
        }
    },
    PDF: {
        TRAVEL_COMPONENTS: {
            PDF_TITLE: "Emissions of the travel components",
            PDF_SUBJECT: "Emissions of the travel components",
            CO2_EMISSIONS_TOTAL_FAILURE: "No CO2 calculation possible.",
            CO2_EMISSIONS_PARTIAL_FAILURE: "Not for very part the CO2 could be calculated.",
            FOOTER: {
                REDUCE_EMISSIONS: "Would you like to reduce your carbon footprint? Your travel agency will be happy to give you tips on how you can travel in a more climate-conscious way.",
                DISCLAIMER: "This data is without guarantee and was determined by: KlimaLink e.V.",
            }

        },
        JOURNEY: {
            PDF_TITLE: 'Your journey and emissions',
            PDF_SUBJECT: "Your journey and Emissions",
        }
    }
}

export default english